import React, { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import { FaArrowRight } from "react-icons/fa";
import { AiOutlineLoading } from "react-icons/ai";
import MessageLabel from "./MessageLabel";
import MessageSubHeading from "./MessageSubHeading";

const AdminAIModal = ({ modelClose, sliderClose, generateSuggestion, applySuggestion, defaultPrompt }) => {
  const [promptText, setPromptText] = useState(defaultPrompt || "");
  const [suggestion, setSuggestion] = useState("");
  const [loading, setLoading] = useState("");
  useEffect(() => {
    setPromptText(defaultPrompt || "");
  }, [defaultPrompt]);

  return (
    <>
      {modelClose && <div className="modal-backdrop fade show"></div>}
      <div className={`modal fade ${modelClose ? "d-block show" : ""}`} tabIndex="-1">
        <div className="modal-dialog modal-lg theme-bg-color rounded-3">
          <div className="modal-content theme-bg-color">
            <div className="modal-header theme-border-bottom-secondary">
              <h5 className="modal-title theme-text-color">Generate Content</h5>
              <button className="bg-transparent theme-text-color" onClick={sliderClose}>
                <IoClose style={{ width: "25px", height: "25px" }} />
              </button>
            </div>

            <div className="modal-body">
              <div className="position-relative mb-3">
                <MessageLabel noMargin text={"Prompt :"} />
                <MessageSubHeading text={" Hint: The prompt is pre-filled for you. You can edit it as needed."} />
                <textarea id="prompt" rows={3} className="form-control pe-5" placeholder="Enter your prompt..." value={promptText} onChange={(e) => setPromptText(e.target.value)} />
                {promptText.trim() !== "" && (
                  <button type="button" className="btn btn-primary position-absolute" style={{ top: "80%", right: "10px", transform: "translateY(-50%)", borderRadius: "50%" }} onClick={() => generateSuggestion(promptText, setSuggestion, setLoading)} > <FaArrowRight /> </button>
                )}
              </div>

              {loading ? (
                <div className="">
                  <MessageLabel text={"Suggestion :"} />
                  <div className="spinner-overlay-ai">
                    <div className="spinner-ai"></div>
                  </div>
                </div>
              ) : (
                <div className="mb-3">
                  <MessageLabel text={"Suggestion :"} />
                  <textarea id="suggestion" rows={5} className="form-control" value={suggestion} onChange={(e) => setSuggestion(e.target.value)} />
                </div>
              )}
            </div>

            <div className="modal-footer border-0">
              <button className="btn bg-transparent theme-text-color" onClick={sliderClose}>Cancel</button>
              <button className="btn btn-primary" onClick={() => applySuggestion(suggestion)}>Use this</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminAIModal;
